<template>
	<div class="form-group" v-if="content">
	    <label :for="'input'+content.contenttype"><strong v-if="!name || name == ''">{{content.contenttype}}</strong><strong v-else>{{ name }}</strong></label> 
	    <div style="position:relative">
			<tooltip v-model="showSave">Saved</tooltip>
		    <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control" :id="'input'+content.contenttype" v-model="content.contentvalue" @blur="saveContent"  @change="isChange = true">
	    </div>
	</div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import Tooltip from '@/components/elements/Tooltip'

export default{
	props:['value','name'],
	data: function(){
		return {
			showSave : false,
			isChange: false,
			content: this.value
		}
	},
	components: {
		Tooltip
	},
	methods: {
		saveContent: function(){
			let vm = this
			if (vm.isChange) {
				
				api.updateConfig(vm.content,function(error,response){
					if (error) {
						console.error(error)
						return
					}
				})
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/input/InputNumber.vue